import React, { useState } from "react";
import { routePaths } from "@/config";
import { TextField, Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import "./ResetPasswordForm.styles.scss";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Loader } from "@/components/Loader/Loader";
import { apiResetPasswordByUserId } from "../../api/auth.api";
import { ToastError, ToastGeneric } from "@/utils/toast";
import { InlineIcon } from "@iconify/react";

type TResetPasswordProps = {
  idUser?: number | null,
  setIsFirstLogin?: React.Dispatch<React.SetStateAction<boolean>>,
  setRefreshPasswordSuccessFull? : React.Dispatch<React.SetStateAction<boolean>>
}

const ResetPasswordForm: React.FC<TResetPasswordProps> = ({ idUser, setIsFirstLogin,setRefreshPasswordSuccessFull }) => {

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const validationSchema: any = Yup.object({
    code: Yup.string().required("Le code OTP est requis !"),
    password: Yup.string().required("Le mot de passe est requis !"),
    confirmPassword: Yup.string().oneOf(
      [Yup.ref("password"), null],
      "Veuillez confirmer votre mot de passe !"
    ),
  });

  const formik = useFormik({
    initialValues: {
      code: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (value) => {
      console.log(value);

      setIsLoading(true);

      apiResetPasswordByUserId(
        "reset-password/" + idUser,
        value
      ).then( (response) => {
        setIsLoading(false);

        if (response?.error) {
          ToastError.fire({ text: response.message, timer: 9000 });
        } else {
          ToastGeneric(
            `Votre mot de passe a été changé, veuillez vous reconnecter pour accéder à la plateforme.`,
            "success",
            3000
          ).fire();
    
          setIsFirstLogin?.(false); 
          setRefreshPasswordSuccessFull?.(true)
          // Pour afficher le formulaire de connexion
          
        }
      }).catch((error) => {
        console.log(error);

        if(error?.response?.data?.message) {
          ToastError.fire({ text: error?.response?.data?.message, timer: 9000 });
        }else {
          ToastError.fire({ text: error, timer: 9000 });
        }

        // setIsFirstLogin?.(false);
        setIsLoading(false);
      })

     
    },
  });

  return (
    <div className="reset-password-container">
      <Loader isLoading={isLoading} />

      <div className="header-part">
        <h1 className="title">RÉINITIALISATION DE MOT DE PASSE</h1>
        <p className="subtitle"> REMPLIR LE FORMULAIRE CI-DESSOUS </p>
      </div>
     
        <div className="form-part">

        <form onSubmit={formik.handleSubmit}>

          <TextField
            placeholder="Code OTP"
            variant="outlined"
            label="OTP"
            name="code"
            value={formik.values.code}
            onChange={formik.handleChange}
            type="text"
          />
           {
              formik.errors.code &&
              <small className="helper-text"> <InlineIcon icon="ci:error-outline" /> {formik.errors.code} </small>
             }

          <TextField
            placeholder="Mot de passe"
            variant="outlined"
            label="Mot de passe"
            name="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            type="password"
          />
           {
              formik.errors.password &&
              <small className="helper-text"> <InlineIcon icon="ci:error-outline" /> {formik.errors.password} </small>
             }

          <TextField
            placeholder="Mot de passe"
            variant="outlined"
            label="Confirmation de mot de passe"
            name="confirmPassword"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            type="password"
          />
           {
              formik.errors.confirmPassword &&
              <small className="helper-text"> <InlineIcon icon="ci:error-outline" /> {formik.errors.confirmPassword} </small>
             }

          <Button
            variant="contained"
            color="tertiary"
            type="submit"
            sx={{ marginTop: "30px" }}
          >
            RÉINITIALISER LE MOT DE PASSE
          </Button>

          </form>

        </div>
        <div className="footer-part">
          <Link
            className="link-primary"
            to={routePaths.authChildren.signInAbsolute} onClick={(e) => setIsFirstLogin?.(false)}
          >
            Connexion 
          </Link>
        </div>
    
    </div>
  );
};

export default ResetPasswordForm;
